import { render, staticRenderFns } from "./InboxNavigator.vue?vue&type=template&id=d67d36dc&scoped=true&"
import script from "./InboxNavigator.vue?vue&type=script&lang=js&"
export * from "./InboxNavigator.vue?vue&type=script&lang=js&"
import style0 from "./InboxNavigator.vue?vue&type=style&index=0&id=d67d36dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67d36dc",
  null
  
)

export default component.exports